"use client";
import useTranslate from "@app/_hooks/useTranslate";
import FeaturedImageWithBackground from "@blocks/CategoryPageComponents/FeaturedImageWithBackground";
import PageFooter from "@blocks/PageFooter";
import ReadMore from "@blocks/ReadMore/ReadMore";
import { LazyRichText } from "@blocks/RichText/LazyRichText";
import type {
  BrandPageFragment,
  CategoryPageFragment,
  DesignerPageFragment,
} from "@server/gql/graphql";

import { Heading } from "@app/_components/ui";
import TextBlock from "../TextBlock";

type FooterProps = {
  data: CategoryPageFragment | BrandPageFragment | DesignerPageFragment;
  market: string;
  locale?: string;
  textBlock?: any;
};

export default function Footer({
  data,
  market,
  locale,
  textBlock,
}: FooterProps) {
  const t = useTranslate();

  if (!data) return null;

  const { subtitle, description } = data;

  return (
    <PageFooter
      showRightColumnOnMobile
      className="category-footer scroll-mt-[55px]"
      rightColumn={
        textBlock && (
          <TextBlock
            bodyClassName="p-4 md:px-6 prose-footer-text bg-[#F8F8F8] flex-1 flex mx-4 md:m-0 mb-12"
            locale={locale}
            market={market}
            {...textBlock}
          />
        )
      }
    >
      <ReadMore
        readLessText={t("readLess")}
        readMoreText={t("readMore")}
        expandOnMobile={true}
      >
        {subtitle && (
          <Heading as="h2" size={4} className="mb-4">
            {subtitle}
          </Heading>
        )}
        <LazyRichText
          content={description}
          locale={locale}
          market={market}
          className="prose-footer-text max-w-full"
        />
      </ReadMore>
      <FeaturedImageWithBackground
        data={data}
        className="mt-6 lg:hidden"
        imageClassName={data.type === "Brand" ? "max-w-44 max-h-44" : ""}
      />
    </PageFooter>
  );
}
